import React from 'react'

export default function Objective() {
  return (
    <section className='mt-5 mb-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>

                <div className='mb-4 '>
                        <h4 className='font-italic d-inline p-1 bg-warning'>Our Objectives</h4><br></br>
                    </div>
                       


                    <div> 
                        <p>The NISSAP identifies seven objectives to realize this vision:
                        </p>

                        <ul>
                            
                            <ol >1. Raising awareness of the negative impacts of invasive species on our natural heritage, economy and people. </ol>
                            <ol>2. Building institutions, skills, infrastructure, technical support, information management systems, networks and exchanges.</ol>
                            <ol>3. Preventing new species from arriving and establishing, or existing species getting to new areas, through early detection and rapid response to reduce ecological, economic and financial pressures.</ol>
                            <ol>4. Monitoring, reporting and recording invasive species to track the threats posed by new and established invasive species and guide the management response.</ol>
                            <ol>5. Mounting Risk Assessment tools that can be used to: (i) identify invasive or potentially invasive species before they are introduced to our country; (ii) estimate the actual and potential impact of an invasive; and (iii) help with prioritizing the key actions necessary to minimize the negative impact and/or manage the invasive species.</ol>
                            <ol>6. Prioritizing actions that can be taken to eradicate small populations of recently-arrived invasive species.</ol>
                            <ol>Reviewing the legislative framework in Antigua and Barbuda to deal with increasing trade and tourism.</ol>
                            
                        </ul>
                    </div>
<br></br>
                    <div>
                        <p>In order to do this, the National Steering Committee will take a wide view of invasive species management, implement a bio-security approach, prioritize the protection of high value environmental and agricultural assets and work in partnership with all stakeholders.</p>
                        <p>The goals, objectives and actions of the National Invasive Species Strategy and Action Plan endeavor to deliver specific measurable outcomes that complement Antigua and Barbuda’s targets for biodiversity enhancement as identified in the Antigua and Barbuda National Strategic Biodiversity Action Plan 2014 – 2020.</p>
                    </div>



                </div>
            </div>
        </div>
    </section>
  )
}
